import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../utils/cn";

const chatBubbleVariants = cva(
  "relative max-w-full px-4 py-3 text-sm leading-relaxed break-words shadow-sm transition-all",
  {
    variants: {
      variant: {
        me: "bg-primary text-primary-foreground rounded-[20px] rounded-tr-[4px]",
        other:
          "bg-background border border-border text-foreground rounded-[20px] rounded-tl-[4px]",
        system:
          "bg-muted/50 text-muted-foreground text-xs px-3 py-1.5 rounded-full shadow-none text-center mx-auto w-fit",
        error:
          "bg-destructive/5 border border-destructive/20 text-destructive rounded-[20px]",
        ghost: "bg-transparent shadow-none p-0 text-foreground", // For custom content like images without bubble
      },
    },
    defaultVariants: {
      variant: "other",
    },
  },
);

interface ChatBubbleProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof chatBubbleVariants> {}

const ChatBubble = React.forwardRef<HTMLDivElement, ChatBubbleProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(chatBubbleVariants({ variant, className }))}
        {...props}
      />
    );
  },
);
ChatBubble.displayName = "ChatBubble";

export { ChatBubble, chatBubbleVariants };
